import { render } from "./App.vue?vue&type=template&id=4cda9b8a&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4cda9b8a&lang=less"
import "./App.vue?vue&type=style&index=1&id=4cda9b8a&lang=less&scoped=true"

import exportComponent from "C:\\code\\zfb_xf_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cda9b8a"]])

export default __exports__